// Official WhatsApp glyph (simplified path). Renders in brand green when brand=true.
export default function WhatsAppIcon({ size = 20, brand = true, className = "" }) {
  const bg = brand ? "#25D366" : "currentColor";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
      aria-hidden
    >
      <path
        fill={bg}
        d="M16.001 3C9.373 3 4 8.373 4 15c0 2.36.69 4.564 1.88 6.42L4 29l7.79-1.84A11.94 11.94 0 0 0 16 27c6.627 0 12-5.373 12-12S22.628 3 16.001 3Z"
      />
      <path
        fill="#ffffff"
        d="M22.14 18.86c-.34-.17-2-.99-2.31-1.1-.31-.11-.53-.17-.75.17-.22.34-.86 1.09-1.06 1.32-.2.22-.39.25-.73.09-.34-.17-1.43-.53-2.72-1.68a10.2 10.2 0 0 1-1.88-2.34c-.2-.34-.02-.53.15-.7.15-.15.34-.39.51-.59.17-.2.22-.34.34-.56.11-.22.06-.42-.03-.59-.08-.17-.75-1.82-1.03-2.49-.27-.65-.55-.56-.75-.57l-.64-.01c-.22 0-.59.08-.9.42-.31.34-1.18 1.15-1.18 2.81 0 1.66 1.21 3.27 1.38 3.5.17.22 2.38 3.63 5.77 5.09.81.35 1.44.56 1.93.72.81.26 1.55.22 2.13.13.65-.1 2-.82 2.28-1.6.28-.79.28-1.46.2-1.6-.08-.14-.31-.22-.65-.39Z"
      />
    </svg>
  );
}
